import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { ApiError } from 'utils/types';

export default function useValidatePhoneNumber() {
  return useMutation<any, ApiError, string, any>({
    mutationFn: async (payload) => {
      const data = await axios.post(
        `${import.meta.env.VITE_APP_END_POINT}/api/public/common/twilio/validate`,
        { phoneNumber: payload },
        {
          headers: {
            Authorization: import.meta.env.VITE_APP_BASIC_AUTH,
          },
        },
      );

      return data.data;
    },
  });
}
